import { useState } from 'react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalFooter,
  ModalHeader,
  ModalCloseButton,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  DrawerCloseButton,
  Button,
  Textarea,
  FormControl,
  FormLabel,
  Text,
} from '@chakra-ui/react';

import mediaQueryStateAtom from '~/recoil/atom/mediaQueryState';
import { useRecoilValue } from 'recoil';
import { BtnVariant } from '~/theme/components/Button';

type CreateGroupModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: (value: string) => void;
};

export default function CreateGroupModal({ isOpen, onClose, onConfirm }: CreateGroupModalProps) {
  const { isLargerThan768 } = useRecoilValue(mediaQueryStateAtom);

  const [text, setText] = useState('');

  return isLargerThan768 ? (
    <Modal size="sm" isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader
          pt={5}
          fontSize="xl"
          borderBottomWidth="1px"
          borderColor="primary"
          textAlign="center"
        >
          我要揪團
        </ModalHeader>
        <ModalBody py={6}>
          <FormControl>
            <FormLabel>給團員的話</FormLabel>
            <Textarea
              resize="none"
              value={text}
              _focus={{ borderColor: 'primary', boxShadow: '0 0 0 1px #E6B369' }}
              onChange={(e) => setText(e.target.value)}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter p={0}>
          <Button
            isFullWidth
            variant={BtnVariant.SOLID_PRIMARY}
            borderRadius="none"
            onClick={() => onConfirm?.(text)}
          >
            確定開團
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  ) : (
    <Drawer size="full" isOpen={isOpen} onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader
          pt={5}
          fontSize="xl"
          borderBottomWidth="1px"
          borderColor="primary"
          textAlign="center"
        >
          我要揪團
        </DrawerHeader>
        <DrawerBody py={6}>
          <FormControl>
            <FormLabel>給團員的話</FormLabel>
            <Textarea
              resize="none"
              value={text}
              _focus={{ borderColor: 'primary', boxShadow: '0 0 0 1px #E6B369' }}
              onChange={(e) => setText(e.target.value)}
            />
          </FormControl>
        </DrawerBody>
        <DrawerFooter p={0} position="sticky" bottom="0">
          <Button
            size="lg"
            isFullWidth
            variant={BtnVariant.SOLID_PRIMARY}
            borderRadius="none"
            onClick={() => onConfirm?.(text)}
          >
            確定開團
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
